import Layout from '@/views/main/Main.vue'
import type { RouteRecordRaw } from "vue-router";
const tagPrintingRouter: RouteRecordRaw = {
    path: '/tagPrinting',
    component: Layout,
    redirect: 'noredirect',
    meta: {
        icon: 'el-icon-user-solid',
        title: '标签打印'
    },
    children: [
        {
            path: '/tagPrinting/carrierTagPrinting',
            component: () => import("@/views/main/tagPrinting/carrierTagPrinting/carrierTagPrinting.vue"),
            name: 'carrierTagPrinting',
            meta: {
                title: '容器标签'
            }
        },
        {
            path: '/tagPrinting/storageTagPrinting',
            component: () => import("@/views/main/tagPrinting/storageTagPrinting/storageTagPrinting.vue"),
            name: 'storageTagPrinting',
            meta: {
                title: '库位标签'
            }
        },
        {
            path: '/tagPrinting/wareTagPrinting',
            component: () => import("@/views/main/tagPrinting/wareTagPrinting/wareTagPrinting.vue"),
            name: 'wareTagPrinting',
            meta: {
                title: '物料标签'
            }
        }
    ]
}
// 标签打印路由
export default tagPrintingRouter